import { gql } from '@apollo/client';
import { FRAGMENT_ACCESS_GROUP } from './fragment.accessGroup';

export const FETCH_ACCESS_GROUPS_FACILITY = gql`
    ${FRAGMENT_ACCESS_GROUP}
    query fetchAccessGroupsFacility {
        facility {
            id
            accessGroups {
                ...accessGroup
            }
        }
    }
`;
